import React, { useEffect } from 'react'
import FAQCard from './FAQCard'

const FAQArray = [
    {
        question: 'Does Optinly offer Shopify email popup?',
        answer: 'Optinly offers multiple redaymade Shopiy email popups. Also, it provides options to easily customize the popup depending upon the user. Shopify email popups are popups used in Shopify websites for collecting quality customer email address. '
    },
    {
        question: 'How many types of Shopify popup form is available in Optinly?',
        answer: 'Optinly offers 6+ types of unique popup forms for Shopify. Each one is engaging and grabs audience attentation without any delay. '
    },
    {
        question: 'Is there a free pricing plan available in Optinly for Shopify stores? ',
        answer: 'Optinly have a free pricing plan that works on Shopify stores. Feel free to check out the entire pricing structure in Optinly pricing page. '
    },
    {
        question: 'Is Shopify exit popup available in Optinly? ',
        answer: 'Yes, Optinly have customer engaging exit popup templates. You can personalize the template or made use of the pre-made one. '
    }
]

const FAQ = ({
    FAQQuestion1, FAQAnswer1,
    FAQQuestion2, FAQAnswer2,
    FAQQuestion3, FAQAnswer3,
    FAQQuestion4, FAQAnswer4,
    FAQQuestion5, FAQAnswer5,
}) => {
    return (
        <>
            <section className="w-full px-2 pt-5 pb-5 mx-auto text-center lg:w-4/5 xs:px-4">
                <h2 className="text-lg font-semibold md:text-xl lg:text-32px font-poppins" style={{color: '#2D2D2D', lineHeight: '50px'}}>Frequently Asked Questions</h2>

                <div className="w-full px-2 pt-10 pb-10 space-y-5 xs:px-4 md:pt-14 lg:pt-20 max-auto">
                    {/* {
                        FAQArray.map((faq, index) => {
                            return (
                                <FAQCard question={faq.question} answer={faq.answer} index={index} />
                            )
                        })
                    } */}
                    <FAQCard question={FAQQuestion1} answer={FAQAnswer1} index={1} />
                    <FAQCard question={FAQQuestion2} answer={FAQAnswer2} index={2} />
                    <FAQCard question={FAQQuestion3} answer={FAQAnswer3} index={3} />
                    <FAQCard question={FAQQuestion4} answer={FAQAnswer4} index={4} />

                    {FAQQuestion5 &&
                        <FAQCard question={FAQQuestion5} answer={FAQAnswer5} index={5} />
                    }
                </div>
            </section>
        </>
    )
}

export default FAQ
